export const mobileViewBreakpoint = (vuetifyBreakpointName) => {
  return vuetifyBreakpointName === 'xs' || vuetifyBreakpointName === 'sm'
}

export default { mobileViewBreakpoint }
